import React from "react";

const Inputs = () => {
  return (
    <div class="flex w-full flex-col gap-8">
      <div class="flex gap-4 items-center">
        <div class="w-1/6">
          <div class="max-w-fit p-4 rounded-md"></div>
        </div>
        <div class="w-[25%]">
          <div class="bg-[--white-05] max-w-fit font-bold py-2 px-4 rounded-full text-[--information]">
            TextArea
          </div>
        </div>
        <div class="w-[25%]">
          <div class="bg-[--white-05] max-w-fit font-bold py-2 px-4 rounded-full text-[--information]">
            Input
          </div>
        </div>
      </div>
      <div class="flex gap-4 items-center">
        <div class="w-1/6">
          <div class="">Filled</div>
        </div>
        <div class="w-[25%]">
          <label>Label</label>
          <textarea value={"filled textarea"} />
        </div>
        <div class="w-[25%]">
          <label>Label</label>
          <input value="filled input" />
        </div>
      </div>
      <div class="flex gap-4 items-center">
        <div class="w-1/6">
          <div class="">Not filled</div>
        </div>
        <div class="w-[25%]">
          <label>Label</label>
          <textarea value={""} placeholder="enter a value.." />
        </div>
        <div class="w-[25%]">
          <label>Label</label>
          <input value="" placeholder="enter a value" />
        </div>
      </div>
      <div class="flex gap-4 items-center">
        <div class="w-1/6">
          <div class="">Disabled</div>
        </div>
        <div class="w-[25%]">
          <label>Label</label>
          <textarea value={"filled textarea"} disabled />
        </div>
        <div class="w-[25%]">
          <label>Label</label>
          <input value="filled input" disabled />
        </div>
      </div>
      <div class="flex gap-4 items-center">
        <div class="w-1/6">
          <div class="">Error</div>
        </div>
        <div class="w-[25%]">
          <label data-has-error={true}>Label</label>
          <div className="relative">
            <textarea value={"textarea with error"} data-has-error={true} />
            <span role="input-error" />
          </div>
        </div>
        <div class="w-[25%]">
          <label data-has-error={true}>Label</label>
          <div className="relative">
            <input value="Input with error" data-has-error={true} />
            <span role="input-error" />
          </div>
        </div>
      </div>
      <div class="flex gap-4 items-center">
        <div class="w-1/6">
          <div class="">Search</div>
        </div>
        <div class="w-[50%]">
          <label>Label</label>
          <input type="search" name="name" placeholder="Search..."></input>
        </div>
      </div>
      <div class="flex gap-4 items-center">
        <div class="w-1/6">
          <div class="">Search expandable</div>
        </div>
        <div class="w-[50%]">
          <label>Label</label>
          <input
            type="search"
            name="name"
            placeholder="Search..."
            data-expandable={true}
          ></input>
        </div>
      </div>
    </div>
  );
};

export default Inputs;
